interface state {
	called: boolean
	result?: Promise<any>
	timer: number
}

const DELAY = 300

const global = new Map<string, state>()

export async function sharedFetch<T>(key: string, fetch: () => Promise<T>): Promise<T> {
	let st = global.get(key)
	if (!st) {
		st = {
			called: false,
			timer: 0,
		}
		global.set(key, st)
	}

	if (!st.called) {
		st.called = true
		st.result = fetch()

		if (st.timer) clearTimeout(st.timer)
		st.timer = setTimeout(() => {
			st.called = false
		}, DELAY)
	}

	return await st.result
}
